<template>
	<div class="wrapper">
		<div class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<div slot="header"><i class="icon-layers"></i> Office Modules</div>
						<div class="d-flex flex-row mb-5">
							<div class="col-2">
								Select Office
							</div>
							<div class="col-6">
								<multiselect @input="getEmployeeList()" v-model="value"
														 :options="officeList"
														 :close-on-select="false"
														 :searchable="true"
														 label = "name"
														 placeholder="Pick a value"></multiselect>
							</div>
						</div>
						<div class="d-flex flex-row mb-5">
							<div class="col-2">
								Payroll Manager
							</div>
							<div class="col-6">
								<multiselect @input="getEmployeeList()" v-model="payrollManager"
														 :options="employeeList"
														 :close-on-select="false"
														 :searchable="true"
														 label = "name"
														 placeholder="Pick a value"></multiselect>
							</div>
							<div class="col-4">
								<b-button variant="success" @click="saveManagerOrApproverConfiguration(1)"><i
									class="fa fa-save px-2"></i> Save
								</b-button>
							</div>
						</div>
						<div class="d-flex flex-row mb-5" v-if="payrollManagerList.length > 0">
							<div class="col-2">
								Current Payroll Managers
							</div>
							<div class="col-9 d-flex flex-column">
								<div v-for="manager in payrollManagerList">
									<div class="row mb-2" >
										<div class="col-8">
											<h5>{{ manager.name }}</h5>
										</div>
										<div class="col-4">
											<b-button variant="danger" @click="removePayrollStaff(manager.id)"><i
												class="fa fa-minus"></i> Remove
											</b-button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex flex-row mb-5">
							<div class="col-2">
								Payroll Approver
							</div>
							<div class="col-6">
								<multiselect  v-model="payrollApprover"
														 :options="employeeList"
														 :close-on-select="false"
														 :searchable="true"
														 label = "name"
														 placeholder="Pick a value"></multiselect>
							</div>
							<div class="col-4">
								<b-button variant="success" @click="saveManagerOrApproverConfiguration(2)"><i
									class="fa fa-save px-2"></i> Save
								</b-button>
							</div>
						</div>
						<div class="d-flex flex-row mb-5" v-if="payrollApproverList.length > 0">
							<div class="col-2">
								Current Payroll Approvers
							</div>
							<div class="col-9 d-flex flex-column">
								<div v-for="approver in payrollApproverList">
									<div class="row mb-2" >
										<div class="col-8">
											<h5>{{ approver.name }}</h5>
										</div>
										<div class="col-4">
											<b-button variant="danger" @click="removePayrollStaff(approver.id)"><i
												class="fa fa-minus"></i> Remove
											</b-button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex flex-row mb-5">
							<div class="col-2">
								Mail Employee
							</div>
							<div class="col-6">
								<multiselect @input="populateMailInformation()" v-model="employeeToSendMail"
														 :options="employeeList"
														 :close-on-select="true"
														 :searchable="true"
														 label = "name"
														 placeholder="Pick an Employee"></multiselect>
							</div>
						</div>
						<div class="d-flex flex-row mb-5">
							<div class="col-2">
								Receiver Name
							</div>
							<div class="col-6">
								<b-form-input v-model="receiverName" name="receive-name" id="name" type="text" placeholder="Name"></b-form-input>
							</div>
						</div>
						<div class="d-flex flex-row mb-5">
							<div class="col-2">
								Mail Address
							</div>
							<div class="col-6">
								<b-form-input v-model="mailAddress" name="email" id="email" type="text" placeholder="Email"></b-form-input>
							</div>
							<div class="col-8">
								<b-button size="sm" pill variant="info" class="m-1" @click="sendActivationEmail()">Send Activation Email</b-button>
							</div>
						</div>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import officeService from '@/services/officeService'
import toastService from '@/services/toastService'

export default {
	name: 'modules',
	components:{Multiselect},
	data() {
		return{
			value:"",
			officeList :[],
			moduleList : [],
			employeeList : [],
			selectedEmployee : "",
			payrollManager: "",
			payrollManagerList: [],
			payrollApprover: "",
			payrollApproverList: [],
			employeeToSendMail : null,
			mailAddress : null,
			receiverName : null,
		}
	},
	methods:{
		fetchVersionModuleData(){
			officeService.getModuleListForOffice(this.value.id,r => {
				this.moduleList = r, e => toastService.showErrorToast(e)
			});
		},
		getEmployeeList(){
			officeService.getEmployeeList(this.value.id, r =>{
				this.employeeList = r;
				this.getPayrollStaffList();
				}, e => toastService.showErrorToast(e)
			);
		},
		getPayrollStaffList(){
			officeService.getPayrollStaffList(this.value.id, r => {
				this.payrollManagerList = r.payrollManagers;
				this.payrollApproverList = r.payrollApprovers;
				// console.log(r);
				}, e => toastService.showErrorToast(e)
			);
		},
		removePayrollStaff(employeeId){
			officeService.removePayrollStaff(employeeId, r => {
				this.getPayrollStaffList();
				// console.log(r);
				}, e => toastService.showErrorToast(e)
			);
		},
		sendActivationEmail(){
			if(!this.receiverName){
				return this.$toasted.error("Receiver name cannot be empty");
			}
			if(!this.mailAddress){
				return this.$toasted.error("Email cannot be empty");
			}
			console.log(this.receiverName);
			console.log(this.mailAddress);
			const data = {employeeName : this.receiverName, email : this.mailAddress}
			officeService.sendPayrollActivationEmail(data , r => this.$toasted.show("Activation mail sent successfully"))
		},
		populateMailInformation(){
			if(this.employeeToSendMail){
				this.mailAddress = this.employeeToSendMail.email;
				this.receiverName = this.employeeToSendMail.name;
			}
		},
		saveManagerOrApproverConfiguration(role){
			console.log("clicked " + role);
			console.log(this.value);
			const request = {
				officeId : this.value.id,
				employeeRole : role
			}
			let employeeId;
			if(role == 1)
				employeeId = this.payrollManager.id;
			else
				employeeId = this.payrollApprover.id;

			officeService.updateManagerOrApproverConfiguration(employeeId, request, r =>{
				toastService.showSuccessToast("Update Successful");
				this.getPayrollStaffList();
				},e =>toastService.showErrorToast(e)
			);
		}

	},
	mounted(){
		officeService.getOfficeList(r => this.officeList = r , e => toastService.showErrorToast(e));
	}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
